import { Avatar } from '@mui/material';
import PersonIcon from '@mui/icons-material/Person';
import { getInitials, getAvatarColor } from '@/utils/userUtils';

type UserAvatarProps = {
  name?: string | null;
  size?: number;
};

export default function UserAvatar({ name, size = 28 }: UserAvatarProps) {
  const initials = getInitials(name);
  const backgroundColor = getAvatarColor(name);

  if (!initials) {
    return (
      <Avatar
        sx={(theme) => ({
          width: size,
          height: size,
          backgroundColor: theme.palette.neutral.light,
          fontSize: size * 0.5,
        })}
      >
        <PersonIcon sx={{ fontSize: size * 0.7 }} />
      </Avatar>
    );
  }

  return (
    <Avatar
      sx={{
        width: size,
        height: size,
        backgroundColor,
        color: 'white',
        fontSize: size * 0.4,
        fontWeight: 600,
      }}
    >
      {initials}
    </Avatar>
  );
}
